module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "chat-button-outer",
    class: {
      'blue-pulse': _vm.mode == 'alert'
    }
  }, [_c('div', {
    staticClass: "elevation-5 chat-button-inner",
    class: {
      'blue-chat-button': _vm.mode == 'alert', 'white-chat-button': _vm.mode == 'open'
    },
    on: {
      "click": _vm.buttonClicked,
      "dblclick": _vm.changeMode
    }
  }, [_c('v-icon', {
    staticClass: "button-icon",
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-chat")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chat-window-outer",
    class: {
      'active': (_vm.mode == 'open')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "elevation-1 chat-window-inner"
  }, [_c('div', {
    staticClass: "pa-2",
    staticStyle: {
      "position": "relative",
      "flex-basis": "1px",
      "background-color": "#eee",
      "border-bottom": "solid 1px #aaa",
      "border-radius": "10px 10px 0 0"
    }
  }, [_c('v-icon', {
    staticClass: "clickable close-chat",
    staticStyle: {
      "font-size": "22px",
      "position": "absolute",
      "width": "20px",
      "height": "20px",
      "top": "5px",
      "right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.mode = 'idle'
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('LabelMenu', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "menus": _vm.menuItems
    },
    model: {
      value: (_vm.office),
      callback: function($$v) {
        _vm.office = $$v
      },
      expression: "office"
    }
  })], 1), _vm._v(" "), _c('ScrollDownDiv', {
    ref: "history",
    staticClass: "pa-2",
    staticStyle: {
      "flex-grow": "1",
      "overflow-y": "auto"
    },
    on: {
      "change": _vm.chatsAdded
    }
  }, [(_vm.messages.length == _vm.messageLimit) ? _c('div', {
    staticClass: "hoverable clickable light-text small-text",
    on: {
      "click": function($event) {
        _vm.messageLimit += 10
      }
    }
  }, [_vm._v("Show More History")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(message) {
    return _c('div', {
      key: message._id,
      staticClass: "chat-message",
      class: {
        reversed: _vm.isMyMessage(message)
      },
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticClass: "chat-message-picture",
      staticStyle: {
        "flex-basis": "40px"
      },
      attrs: {
        "src": message.user.image
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-grow": "1"
      }
    }, [_c('div', {
      staticClass: "chat-message-text",
      class: {
        'chat-message-blue': _vm.isMyMessage(message)
      }
    }, [_vm._v("\n                            " + _vm._s(message.text) + " "), _c('span', {
      staticClass: "light-text small-text"
    }, [_vm._v(_vm._s(_vm._f("timeAgo")(message.createdAt)))])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pa-2",
    staticStyle: {
      "flex-basis": "35px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    ref: "messageText",
    staticClass: "quick-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.saveMessage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e350072"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ChatWindow.vue
// module id = 2538
// module chunks = 1